import { BasketballGameLogTypes } from '../models/basketball-game-log';
import { Locales } from './locales';

export const BasketballGameLogTypeLocalization = {
  [Locales.ru]: {
    [BasketballGameLogTypes.enter_game]: 'Выход на площадку',
    [BasketballGameLogTypes.exit_game]: 'Ушел с площадки',
    [BasketballGameLogTypes.remove_game]: 'Удаление с площадки',
    [BasketballGameLogTypes.two_point_attempt]: 'Бросок 2 очка',
    [BasketballGameLogTypes.three_point_attempt]: 'Бросок 3 очка',
    [BasketballGameLogTypes.free_throw_attempt]: 'Штрафной бросок',
    [BasketballGameLogTypes.one_point_attempt]: 'Бросок 1 очко',
    [BasketballGameLogTypes.two_point_made]: '2 очка',
    [BasketballGameLogTypes.three_point_made]: '3 очка',
    [BasketballGameLogTypes.free_throw_made]: '1 очко, штрафной',
    [BasketballGameLogTypes.one_point_made]: '1 очко',
    [BasketballGameLogTypes.assist]: 'Передача',
    [BasketballGameLogTypes.block]: 'Блокшот',
    [BasketballGameLogTypes.rebound]: 'Подбор',
    [BasketballGameLogTypes.offensive_rebound]: 'Подбор в нападении',
    [BasketballGameLogTypes.defensive_rebound]: 'Подбор в защите',
    [BasketballGameLogTypes.steal]: 'Перехват',
    [BasketballGameLogTypes.turnover]: 'Потеря',
    [BasketballGameLogTypes.personal_foul]: 'Фол',
    [BasketballGameLogTypes.technical_foul]: 'Технический фол',
    [BasketballGameLogTypes.unsportsmanlike_foul]: 'Неспортиный фол',
    [BasketballGameLogTypes.disqualification_foul]: 'Дисквалифицирующий фол',
    [BasketballGameLogTypes.timeout]: 'Таймаут',
    [BasketballGameLogTypes.team_rebound]: 'Командный подбор',
    [BasketballGameLogTypes.dunk_attempt]: 'Данк мимо',
    [BasketballGameLogTypes.dunk_made]: 'Данк',
    [BasketballGameLogTypes.four_point_attempt]: 'Бросок 4 очка',
    [BasketballGameLogTypes.four_point_made]: '4 очка',
    [BasketballGameLogTypes.shootout]: 'Буллит',
    [BasketballGameLogTypes.shootout_won]: 'Буллит выигран',
    [BasketballGameLogTypes.shootout_lost]: 'Буллит проигран',
    [BasketballGameLogTypes.moneyball_free_throw_attempt]: 'Штрафной бросок',
    [BasketballGameLogTypes.moneyball_free_throw_made]: '2 очка, штрафной',
  },
  [Locales.en]: {
    [BasketballGameLogTypes.enter_game]: 'Entering the court',
    [BasketballGameLogTypes.exit_game]: 'Exit the court',
    [BasketballGameLogTypes.remove_game]: 'Remove from the court',
    [BasketballGameLogTypes.two_point_attempt]: 'Two point attempt',
    [BasketballGameLogTypes.three_point_attempt]: 'Three point attempt',
    [BasketballGameLogTypes.free_throw_attempt]: 'Free throw attempt',
    [BasketballGameLogTypes.one_point_attempt]: 'One point attempt',
    [BasketballGameLogTypes.two_point_made]: '2 points',
    [BasketballGameLogTypes.three_point_made]: '3 points',
    [BasketballGameLogTypes.free_throw_made]: '1 point, free throw',
    [BasketballGameLogTypes.one_point_made]: '1 point',
    [BasketballGameLogTypes.assist]: 'Assist',
    [BasketballGameLogTypes.block]: 'Block',
    [BasketballGameLogTypes.rebound]: 'Rebound',
    [BasketballGameLogTypes.offensive_rebound]: 'Offensive rebound',
    [BasketballGameLogTypes.defensive_rebound]: 'Defensive rebound',
    [BasketballGameLogTypes.steal]: 'Steal',
    [BasketballGameLogTypes.turnover]: 'Turnover',
    [BasketballGameLogTypes.personal_foul]: 'Foul',
    [BasketballGameLogTypes.technical_foul]: 'Technical foul',
    [BasketballGameLogTypes.disqualification_foul]: 'Disqualification foul',
    [BasketballGameLogTypes.unsportsmanlike_foul]: 'Unsportsmanlike foul',
    [BasketballGameLogTypes.timeout]: 'Timeout',
    [BasketballGameLogTypes.team_rebound]: 'Team rebound',
    [BasketballGameLogTypes.four_point_attempt]: 'Four point attempt',
    [BasketballGameLogTypes.four_point_made]: '4 points',
    [BasketballGameLogTypes.dunk_attempt]: 'Dunk miss',
    [BasketballGameLogTypes.dunk_attempt]: 'Dunk',
    [BasketballGameLogTypes.shootout]: 'Shootout',
    [BasketballGameLogTypes.shootout_won]: 'Shootout won',
    [BasketballGameLogTypes.shootout_lost]: 'Shootout lost',
    [BasketballGameLogTypes.moneyball_free_throw_attempt]: 'Free throw attempt',
    [BasketballGameLogTypes.moneyball_free_throw_made]: '2 points, free throw',
  }
};
